<template>
  <div class="inventory-data">
    <div className="name">
      {{ data.measuredQuantity }}
      {{ data.productInventory.product.name }}
    </div>
  </div>
</template>

<script>

export default {
    name: 'InventoryData',

    props: {
        data: {
            type: Object,
            default: () => ({
            }),
        },
    },
};
</script>

<style lang="scss" scoped>
.inventory-data {
    width: 100%;

    margin-right: 8px;
    color: black;
    font-size: 12px;
}
</style>
